const experience = [
  {
    title: "Co-Founder & CTO",
    company: "Totowala Technologies Pvt. Ltd.",
    period: "Nov 2025 – Present",
    responsibilities: [
      "Co-founded a driver-first ride-booking platform (Toto, Bike, Cab, Auto) now serving 8,000+ users with 750+ rides completed, on a zero-commission, transparent-pricing model",
      "Own the full engineering stack, leading tech decisions across React, Node.js, Express, and Tailwind CSS",
      "Built Totowala rider and driver Android apps (Java) with real-time booking, GPS tracking, and driver payouts",
      "Built Trico, an internal admin panel for driver and user management, ride oversight, and platform operations",
      "Built an internal Learning Management System (LMS) for onboarding and training"
    ]
  },
  {
    title: "Junior Software Developer",
    company: "EasyLearningTre",
    period: "Nov 2023 – Nov 2025",
    responsibilities: [
      "Reduced website loading time from 10-13 seconds to 1 second, improving Google PageSpeed score from 50+ to 90+",
      "Built comprehensive Learning Management System using ReactJS, Bunny.net, and Supabase with video lectures, quizzes, and progress tracking",
      "Developed ride booking Android app using Java and Firebase with real-time booking, Google Maps integration, and SOS functionality",
      "Integrated multiple payment gateways (PhonePe, Stripe) for seamless transaction processing",
      "Built Quantum CRM, an internal lead management system using ReactJS and Supabase for 10-15 employees with automated email campaigns via Zoho Mail API",
      "Revamped legacy website using Tailwind CSS, modernizing design and improving user experience"
    ]
  }
];

export default experience;